module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_1_0.b16ebe06.png";